<i18n>
{
  "en": {
    "paymentType": {
      "label": "Payment Type",
      "creditCard": "Credit Card",
      "account": "Account Code"
    },
    "accountCode": {
      "label": "Account Code",
      "placeholder": "Existing Account Code"
    },
    "creditCard": {
      "number": {
        "label": "Credit Card",
        "placeholder": "Card #"
      },
      "expiration": {
        "label": "Expiration",
        "month": {
          "placeholder": "Month",
          "jan": "January",
          "feb": "February",
          "mar": "March",
          "apr": "April",
          "may": "May",
          "jun": "June",
          "jul": "July",
          "aug": "August",
          "sep": "September",
          "oct": "October",
          "nov": "November",
          "dec": "December"
        },
        "year": {
          "placeholder": "Year"
        }
      },
      "code": {
        "label": "CVC",
        "placeholder": "CVC"
      }
    }
  }
}
</i18n>
<template>
<div>
    <form id="paymentForm" class="ui form">
      <input type="hidden" name="dataValue" id="dataValue" />
      <input type="hidden" name="dataDescriptor" id="dataDescriptor" />

      <div class="field">
        <label>{{ $t('paymentType.label') }}</label>
        <select v-on:change="checkOnChange()" v-model="paymentType" class="ui fluid search dropdown" name="expMonth">
          <option value="cc">{{ $t('paymentType.creditCard') }}</option>
          <option value="acct">{{ $t('paymentType.account') }}</option>
        </select>
      </div>
      
      <div v-if="paymentType === 'acct'">
        <div class="fields">
          <div class="sixteen wide field">
            <label>{{ $t('accountCode.label') }}</label>
            <imask-input
              v-on:change="checkOnChange()"
              v-model="accountCode"
              :mask="'aa-00000-a'"
              :lazy="true"
              radix="."
              type="text"
              name="accountCode"
              id="accountCode"
              maxlength="16"
              :placeholder="$t('accountCode.placeholder')"
            />
          </div>
        </div>
      </div>

      <div v-if="paymentType === 'cc'">
        <div class="fields">
          <div class="seven wide field">
            <label>{{ $t('creditCard.number.label') }}</label>
            <input v-on:change="checkOnChange()" v-model="cardInfo.cardNumber" type="text" name="cardNumber" id="cardNumber" maxlength="16" :placeholder="$t('creditCard.number.placeholder')">
          </div>
          <div class="three wide field">
            <label>{{ $t('creditCard.code.label') }}</label>
            <input v-on:change="checkOnChange()" v-model="cardInfo.cardCode" type="text" name="cardCode" id="cardCode" maxlength="4" :placeholder="$t('creditCard.code.placeholder')">
          </div>
          <div class="six wide field">
            <label>{{ $t('creditCard.expiration.label') }}</label>
            <div class="two fields">
              <div class="field">
                <select v-on:change="checkOnChange()" v-model="cardInfo.cardExpMonth" class="ui fluid search dropdown" name="expMonth">
                  <option value="">{{ $t('creditCard.expiration.month.placeholder') }}</option>
                  <option value="1">{{ $t('creditCard.expiration.month.jan') }}</option>
                  <option value="2">{{ $t('creditCard.expiration.month.feb') }}</option>
                  <option value="3">{{ $t('creditCard.expiration.month.mar') }}</option>
                  <option value="4">{{ $t('creditCard.expiration.month.apr') }}</option>
                  <option value="5">{{ $t('creditCard.expiration.month.may') }}</option>
                  <option value="6">{{ $t('creditCard.expiration.month.jun') }}</option>
                  <option value="7">{{ $t('creditCard.expiration.month.jul') }}</option>
                  <option value="8">{{ $t('creditCard.expiration.month.aug') }}</option>
                  <option value="9">{{ $t('creditCard.expiration.month.sep') }}</option>
                  <option value="10">{{ $t('creditCard.expiration.month.oct') }}</option>
                  <option value="11">{{ $t('creditCard.expiration.month.nov') }}</option>
                  <option value="12">{{ $t('creditCard.expiration.month.dec') }}</option>
                </select>
              </div>
              <div class="field">
                <select v-on:change="checkOnChange()" v-model="cardInfo.cardExpYear" class="ui fluid search dropdown" name="expYear">
                  <option value="">{{ $t('creditCard.expiration.year.placeholder') }}</option>
                  <option v-for="index in 50" :key="index" :value="index + 2018">
                    {{ index + 2018 }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import { anet } from './mixins/clients/anet.js'
  import { lumberjacque } from './mixins/clients/lumberjacque.js'
  import {IMaskComponent} from 'vue-imask'

  export default {
    name: 'Payment',
    mixins: [anet, lumberjacque],
    props: {
      reservation: Object
    },
    data: function () {
      return {
        paymentType: 'cc',
        cardInfo: {
          cardNumber: '',
          cardCode: '',
          cardExpMonth: '',
          cardExpYear: ''
        },
        accountCode: '',
        paymentFunction: {
          type: null,
          function: null
        },
        complete: false
      }
    },
    components: {
      'imask-input': IMaskComponent
    },
    methods: {
      someMethod: function () {
        return 0
      },
      checkOnChange: function () {
        this.complete = this.isComplete()
        // sets function to be run at request time if all fields are complete
        if (this.complete) {
          if (this.paymentType === 'cc') {
            this.paymentFunction.type = 'cc'
            this.paymentFunction.function = (responseHandler) => this.verify(responseHandler)
          } else {
            this.paymentFunction.type = 'ac'
            this.paymentFunction.function = (responseHandler) => responseHandler(this.accountCode)
          }
        } else {
          this.paymentFunction.type = null
          this.paymentFunction.function = null
        }
        this.$emit('paymentFunctionUpdated', { paymentFunction: this.paymentFunction })
      },
      isComplete: function () {
        // returns boolean representing if any required fields are blank
        var ccResults = [
          this.cardInfo.cardNumber === '',
          this.cardInfo.cardExpMonth === '',
          this.cardInfo.cardExpYear === '',
          this.cardInfo.cardCode === ''
        ]
        var acResults = [
          this.accountCode === ''
        ]
        var results = this.paymentType === 'cc' ? ccResults : acResults
        var complete = !results.some((b) => b)
        this.remoteLog('INFO', 'Payment.vue', 'isComplete', {'paymentType': this.paymentType, 'complete': complete})
        return complete
      },
      verify: function (responseHandler) {
        var nonce = this.getNonce(
          this.cardInfo.cardNumber,
          this.cardInfo.cardExpMonth,
          this.cardInfo.cardExpYear,
          this.cardInfo.cardCode,
          responseHandler
        )
        this.remoteLog('INFO', 'Payment.vue', 'verify', {'nonce': nonce})
        // I don't think this will be anything
        return nonce
      }
    },
    mounted: function () {
      $('select.dropdown').dropdown()
    }
  }
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/Payment.vue